const moduleKey = "machineOverviewContainerDrBoy";

export const machineOverviewContainerDrBoyEn = {
  [moduleKey]: {
    job: "Job",
    targetPartQuantityGoodTotal: "Target Part Quantity (Good / Total)",
    progress: "Progress",
    cycleTime: "Cycle Time",
    timeRemaining: "Time Remaining",
    effectivity: "Effectivity",
    lastUpdated: "Last updated",
    noDataAvailable: "No machine data available for the past 30 minutes.",
    secondsShort: "s",
  },
};

export const machineOverviewContainerDrBoyPtBr = {
  [moduleKey]: {
    job: "Trabalho",
    targetPartQuantityGoodTotal: "Quantidade alvo de pecas (Boas / Total)",
    progress: "Progresso",
    cycleTime: "Tempo de ciclo",
    timeRemaining: "Tempo restante",
    effectivity: "Efetividade",
    lastUpdated: "Ultima atualizacao",
    noDataAvailable: "Sem dados de maquina disponiveis nos ultimos 30 minutos",
    secondsShort: "s",
  },
};

export const machineOverviewContainerDrBoyDe = {
  [moduleKey]: {
    job: "Auftrag",
    targetPartQuantityGoodTotal: "Zielteilemenge (Gut / Gesamt)",
    progress: "Fortschritt",
    cycleTime: "Zykluszeit",
    timeRemaining: "Verbleibende Zeit",
    effectivity: "Effektivitat",
    lastUpdated: "Zuletzt aktualisiert",
    noDataAvailable: "Keine Maschinendaten in den letzten 30 Minuten verfügbar",
    secondsShort: "s",
  },
};

export const machineOverviewContainerDrBoyZhHans = {
  [moduleKey]: {
    job: "作业",
    targetPartQuantityGoodTotal: "目标零件数量（良品 / 总数）",
    progress: "进度",
    cycleTime: "周期时间",
    timeRemaining: "剩余时间",
    effectivity: "有效率",
    lastUpdated: "最后更新",
    noDataAvailable: "过去30分钟内此机器暂无可用数据",
    secondsShort: "秒",
  },
};

export const machineOverviewContainerDrBoyIt = {
  [moduleKey]: {
    job: "Lavoro",
    targetPartQuantityGoodTotal: "Quantita target pezzi (Buoni / Totale)",
    progress: "Progresso",
    cycleTime: "Tempo ciclo",
    timeRemaining: "Tempo rimanente",
    effectivity: "Effettivita",
    lastUpdated: "Ultimo aggiornamento",
    noDataAvailable:
      "Nessun dato disponibile per questa macchina negli ultimi 30 minuti",
    secondsShort: "s",
  },
};

export const machineOverviewContainerDrBoyEs = {
  [moduleKey]: {
    job: "Trabajo",
    targetPartQuantityGoodTotal: "Cantidad objetivo de piezas (Buenas / Total)",
    progress: "Progreso",
    cycleTime: "Tiempo de ciclo",
    timeRemaining: "Tiempo restante",
    effectivity: "Efectividad",
    lastUpdated: "Ultima actualizacion",
    noDataAvailable:
      "No hay datos de maquina disponibles en los ultimos 30 minutos",
    secondsShort: "s",
  },
};

export const machineOverviewContainerDrBoyNl = {
  [moduleKey]: {
    job: "Taak",
    targetPartQuantityGoodTotal: "Doelonderdelenhoeveelheid (Goed / Totaal)",
    progress: "Voortgang",
    cycleTime: "Cyclustijd",
    timeRemaining: "Resterende tijd",
    effectivity: "Effectiviteit",
    lastUpdated: "Laatst bijgewerkt",
    noDataAvailable:
      "Geen machinegegevens beschikbaar voor de afgelopen 30 minuten.",
    secondsShort: "s",
  },
};

export const machineOverviewContainerDrBoyTr = {
  [moduleKey]: {
    cycleTime: "Döngü Süresi",
    effectivity: "Verimlilik",
    job: "İş",
    lastUpdated: "Son güncelleme",
    noDataAvailable: "Son 30 dakikaya ait makine verisi yok.",
    progress: "İlerlemek",
    secondsShort: "S",
    targetPartQuantityGoodTotal: "Hedef Parça Miktarı (İyi / Toplam)",
    timeRemaining: "Kalan Süre",
  },
};
